<template>
  <v-app-bar
    class="main-toolbar"
    :color="!isStandalone ? 'blue' : 'white'"
    :dark="!isStandalone"
    fixed
    app
    :tabs="!!$slots['tabs']"
    :flat="!this.$store.state.map.show"
  >
    <v-btn v-if="prevRoute" tag="v-btn" icon class="elevation-0" @click="$router.push(prevRoute)">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-btn v-else-if="toggleDrawer" tag="v-btn" icon class="elevation-0" @click="$emit('toggleDrawer')">
      <v-icon>mdi-menu</v-icon>
    </v-btn>

    <v-toolbar-title :class="{ 'ml-0': prevRoute || toggleDrawer }">{{ title }}</v-toolbar-title>
    <div class="flex-grow-1"></div>

    <slot name="buttons"></slot>

    <div class="hidden-sm-and-down">
      <ToolbarApps v-if="!isStandalone"></ToolbarApps>
      <ToolbarUser></ToolbarUser>
    </div>

    <slot slot="extension" name="tabs"></slot>
  </v-app-bar>
</template>

<script>
import ToolbarUser from '@/components/ToolbarUser'
import ToolbarApps from '@/components/ToolbarApps'

export default {
  components: {
    ToolbarUser,
    ToolbarApps
  },

  props: {
    title: {
      type: String,
      required: true
    },
    prevRoute: {
      type: Object,
      required: false,
      default: null
    },
    toggleDrawer: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    isStandalone() {
      return window.matchMedia('(display-mode: standalone)').matches
    }
  }
}
</script>
